export default {
  NETWORK_SERVICE: {
    ERRORS: {
      INVALID_REQUEST_PARAMS: 'Invalid request parameters.',
      INVALID_RESPONSE_DATA: 'Invalid Response Data',
      SERVER_IS_UNAVAILABLE: 'The server is unavailable.',
      RESPONSE_PARSING_ERROR: 'Unable to parse response.'
    },
    REQUEST_METHODS: {
      DELETE: 'delete',
      PATCH: 'patch',
      POST: 'post',
      PUT: 'put',
      GET: 'get'
    }
  },
  // `id` matches the backend product id (same values as `productsData` below). ADMIN has none,
  // and the weekly report spans several products, so neither carries one.
  PRODUCTS: {
    RMT: { path: 'srmt', id: 1 },
    AML: { path: 'aml', id: 2 },
    LCRMT: { path: 'lcrmt', id: 4 },
    ADMIN: { path: 'admin' },
    CRMT: { path: 'crmt', id: 8 },
    GRMT: { path: 'grmt', id: 32 },
    // Standalone feature: reads across SRMT, CRMT and GRMT, so it is not nested in any of them.
    RISK_WEEKLY_REPORT: { path: 'risk-weekly-report' }
  }
};

export const productsData = [
  { Id: 1, Name: 'SRMT' },
  { Id: 2, Name: 'AML & RG' },
  { Id: 4, Name: 'LCRMT' },
  { Id: 8, Name: 'CRMT' },
  { Id: 32, Name: 'GRMT' }
];

export const UserGroupData = [{Id: 7, Name: 'All'}, {Id: 1, Name: 'Vbet'}, {Id: 2, Name: 'SoftConstruct'}, {Id: 4, Name: 'Partner'}];

export const UserGroupDataMap = {
  All: 7,
  Vbet: 1,
  Soft: 2,
  Partner: 4
}